// Dual-currency helpers — USD + INR (Indian numeric scale).
// Conversion rate is a fixed constant; update USD_TO_INR here when needed.
// All inputs are USD numbers. INR is derived; backend stores USD only.
//
// Indian numeric scale:
//   1 Lakh (L)  = 1e5 INR
//   1 Crore (Cr) = 1e7 INR
//   1 K Cr      = 1e10 INR  (i.e. 1,000 Cr)
//
// NOTE: The brief's example helper used `inr >= 1e9` as the K-Cr threshold,
// which would render $28M (2.3e9 INR) as "₹2.3K Cr" instead of the brief's
// own expected "₹232 Cr". The corrected threshold (1e10) matches the
// brief's verification examples ($28M → ₹232 Cr, $600M → ₹4.98K Cr, etc.).

export const USD_TO_INR = 83;

export function formatUSD(usd) {
  if (usd == null || isNaN(usd)) return null;
  const a = Math.abs(usd);
  if (a >= 1e9) return `$${(usd / 1e9).toFixed(1)}B`;
  if (a >= 1e6) return `$${(usd / 1e6).toFixed(a >= 1e7 ? 0 : 1)}M`;
  if (a >= 1e3) return `$${(usd / 1e3).toFixed(0)}K`;
  return `$${Math.round(usd)}`;
}

export function formatINR(usd) {
  if (usd == null || isNaN(usd)) return null;
  const inr = usd * USD_TO_INR;
  const a = Math.abs(inr);
  if (a >= 1e10) return `₹${(inr / 1e10).toFixed(a >= 1e11 ? 0 : 2)}K Cr`;
  if (a >= 1e7)  return `₹${(inr / 1e7).toFixed(a >= 1e8 ? 0 : 1)} Cr`;
  if (a >= 1e5)  return `₹${(inr / 1e5).toFixed(1)} L`;
  if (a >= 1e3)  return `₹${Math.round(inr).toLocaleString("en-IN")}`;
  return `₹${Math.round(inr)}`;
}

// Combined inline display for big numbers (e.g. market sizing badges).
export function formatUSDWithINR(usd) {
  const u = formatUSD(usd);
  const i = formatINR(usd);
  if (!u) return "—";
  if (!i) return u;
  return `${u}  ·  ${i}`;
}

// For BoM / table cells where USD and INR render on separate lines.
export function dualCurrency(usd) {
  return { usd: formatUSD(usd), inr: formatINR(usd) };
}
